module.exports = __webpack_public_path__ + "static/media/img-10.1fdca989.png";